import type { JSX } from "preact";
import { useMemo } from "preact/hooks";
import { MenuLoginButton } from "./MenuLoginButton";
import type { MenuNode } from "./MenuNodes";
import { getMenuNodes, getResultsUrl, resultsMenuNode } from "./MenuNodes";
import { Navbar, NavbarNav } from "./Navbar";
import type { NavMenuPathNode } from "./NavMenu";
import { NavMenu } from "./NavMenu";

export function Menu(): JSX.Element | null {
    const nodes = useMemo(() => {
        return getMenuNodes()
            .filter((n) => !n.hidden)
            .map(toNavNode)
            .concat([
                {
                    path: getResultsUrl(),
                    children: resultsMenuNode.name,
                    className: "external-menu-link",
                    absolute: true,
                },
            ]);
    }, []);

    return (
        <Navbar>
            <NavMenu
                variant="navbar"
                className="me-auto ms-3"
                activeNode={getActiveNode(nodes)}
            >
                {nodes}
            </NavMenu>

            <NavbarNav>
                <MenuLoginButton translation={loginButtonTranslation} />
            </NavbarNav>
        </Navbar>
    );
}

const loginButtonTranslation = {
    menu: {
        login: "Logga in",
        logout: "Logga ut",
    },
    error: {
        login: "Kan ej logga in",
        logout: "Kan ej logga ut",
    },
};

function toNavNode(node: MenuNode): NavMenuPathNode {
    return {
        path: node.path,
        children: node.name,
        absolute: true,
    };
}

function getActiveNode(nodes: NavMenuPathNode[]): NavMenuPathNode {
    const { pathname } = window.location;
    const res = nodes.find((n) => pathname.startsWith(n.path));
    // No active link is found: Default to first one.
    return res ?? nodes[0];
}
